<template>
  <div class="ticketTypes">
    <Tabs
      :tabs="activeTicketTypes"
      :activeTab="this.activeTicketType"
      buttonType="rounded"
      :preserveActiveTab="true"
      @change="handleChange" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isNil } from 'lodash';
import Tabs from '../../Tabs';
import { eventBus } from '../../../utility';


export default {
  name: 'BetslipTicketTypes',
  components: {
    Tabs,
  },
  computed: {
    ...mapGetters('gamesBetslip', [
      'activeTicketType',
      'activeTicketTypes',
      'isManualMode',
      'isSingle',
      'isCombo',
      'minBetPayment',
      'minBetPaymentForBet',
      'ticket',
    ]),
    ...mapGetters('notifications', ['isNotificationActive', 'callback']),
  },
  methods: {
    ...mapActions('gamesBetslip', [
      'callTotalPaymentSplitAlgorithm',
      'calculateTotalPayment',
      'calculatePossibleWinCombo',
      'calculateTotalOdds',
      'findDuplicateEventsAndLock',
      'findDuplicateEventsAndUnlock',
      'setActiveTicketType',
      'setTicket',
      'setTotalPaymentValue',
      'setIsTotalPaymentValid',
      'validateTotalPayment',
      'validateAllBets',
    ]),
    ...mapActions('notifications', ['clearNotification']),
    async callSingleActions() {
      this.findDuplicateEventsAndUnlock(this.ticket);

      if (this.isManualMode) {
        await this.callTotalPaymentSplitAlgorithm();
      }

      if (this.ticket.length && !this.isManualMode) {
        await this.calculateTotalPayment();
      }

      await this.validateAllBets();
    },
    async callComboActions() {
      if (!this.isManualMode && this.ticket.length) {
        await this.setTotalPaymentValue(this.minBetPayment);
        await this.setIsTotalPaymentValid(true);
      }

      this.calculateTotalOdds();
      this.calculatePossibleWinCombo();
    },
    async handleChange(value) {
      this.setActiveTicketType(value);

      await this.clearNotification();

      if (this.isSingle) {
        await this.callSingleActions();
        await this.validateTotalPayment();
      }

      if (this.isCombo) {
        await this.callComboActions();
        await this.findDuplicateEventsAndLock(this.ticket);
        await this.validateTotalPayment();
      }

      eventBus.$emit('formatBetslipInputValue');
    },
  },
  beforeMount() {
    const initialActiveTicketType = isNil(this.activeTicketType?.id)
      ? this.activeTicketTypes[0]
      : this.activeTicketType;

    this.setActiveTicketType(initialActiveTicketType);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tabs {
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  background-color: var(--background-1);

  .tab-button {
    background-color: var(--background-1);
    border-bottom: 2px solid transparent;

    button {
      background-color: var(--background-1);
      font-weight: normal;
      height: 30px;
      border: 1px solid var(--button);
      border-radius: 2px;

      &.active {
        border: 1px solid var(--secondary);
        border-radius: 2px;
      }
    }
  }
}
</style>
